<article class="border-border flex items-start gap-2.5 rounded-2xl border bg-white p-3">
  <img
    [src]="comment().participant | participantAvatar"
    [alt]="comment().participant.name"
    class="size-8 shrink-0 rounded-full object-cover" />
  <div class="min-w-0">
    <p class="text-ink text-sm font-semibold">{{ comment().participant.name }}</p>
    <p class="text-ink/80 mt-0.5 text-sm break-words">{{ comment().body }}</p>
  </div>
</article>
